import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BrandCategoriesStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import { BrandCategoryModel, ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import Tab from "@insite/mobius/Tab";
import TabGroup from "@insite/mobius/TabGroup";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, NISCO, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import loadBrandCategories from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrandCategories";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getContentByVersionPath } from "@insite/client-framework/Services/ContentService";
import { getSelectedBrandPath, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getBrandStateByPath } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { IconPresentationProps } from "@insite/mobius/Icon";
import NISBrandTopCategoryProductsGridCard from "@tCentro/Components/NISBrandTopCategoryProductsGridCard";
import loadBrandCategoryProducts from "@tCentro/Handlers/LoadBrandCategoryProducts";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import getColor from "@insite/mobius/utilities/getColor";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import CENDropDownIcon from "@tCentro/Icons/CENDropDownIcon";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Button from "@insite/mobius/Button";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const enum fields {
    title = "title",
    showImages = "showImages",
    subCategoriesToShow = "subCategoriesToShow",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.showImages]: boolean;
        [fields.subCategoriesToShow]: number;
    };
}

interface OwnProps {
    id: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const { pathname, search } = getLocation(state);
    const brandPath =
        getSelectedBrandPath(state) ||
        (pathname === getContentByVersionPath ? parseQueryString<{ brandPath: string }>(search).brandPath : "") ||
        pathname;
    const brandState = getBrandStateByPath(state, brandPath);
    const brandCategoriesParameter = {
        brandId: brandState.value?.id || "",
        page: 1,
        pageSize: 3,
        sort: "name",
        maximumDepth: 1,
    };

    return {
        brandCategoriesParameter,
        productSettings: getSettingsCollection(state).productSettings,
        configurationSelection: state.pages.productDetails.configurationSelection,
        configurationCompleted: state.pages.productDetails.configurationCompleted,
        variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
        subscription: state.pages.productDetails.subscription,
        products: getProductsForProductInfoList(state, ownProps.id),
    };
};

const mapDispatchToProps = { loadBrandCategories, loadProducts, loadBrandCategoryProducts };

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface BrandDetailsCategoriesStyles {
    title?: TypographyProps;
    container?: InjectableCss;
    categoryContainer?: GridContainerProps;
    categoryItem?: GridItemProps;
    categoryItemColumn?: GridItemProps;
    innerCategoryContainer?: GridContainerProps;
    categoryImageItem?: GridItemProps;
    categoryImageLink?: LinkPresentationProps;
    categoryImage?: ImgProps;
    categoryNameLinkItem?: GridItemProps;
    categoryNameLink?: LinkProps;
    categoryWrapper?: InjectableCss;
    subCategoryItem?: GridItemProps;
    subCategoryLink?: LinkProps;
    viewMoreLinkItem?: GridItemProps;
    viewMoreLink?: LinkProps;
    imageWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    compareWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    imageProductWrapper?: InjectableCss;
    moreOptionsStyles?: InjectableCss;
    wrenchIconStyles?: IconPresentationProps;
    configureProductPlpStyles?: InjectableCss;
    mainWrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    cardStyles?: InjectableCss;
    topicsSelect?: SelectPresentationProps;
    spinner?: LoadingSpinnerProps;
    buttonContainer?: InjectableCss;
    button?: InjectableCss;
}

export const categoriesStyles: BrandDetailsCategoriesStyles = {
    button: {
        css: css`
            border-radius: 4px;
            background-color: #2b5197;
            color: white;
            padding: 12px 16px;
            text-transform: uppercase;
            background-color: #2b5197;
            > span {
                font-size: 18px;
                line-height: 18px;
                font-weight: 700;
                font-family: "Roboto Condensed";
            }
        `,
    },
    buttonContainer: {
        css: css`
            display: flex;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 32px;
                    `,
                    css`
                        margin-top: 40px;
                    `,
                    css`
                        margin-top: 40px;
                    `,
                ])}
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    topicsSelect: {
        iconProps: {
            src: CENDropDownIcon,
            css: css`
                width: 28px !important;
                height: 28px !important;
                top: 6px !important;
                right: 24px !important;
            `,
        },
        cssOverrides: {
            formField: css`
                label {
                    font-size: ${TYPOGRAPHY.size.smaller};
                    font-weight: ${TYPOGRAPHY.weight.base};
                    line-height: 14px;
                    color: #333333 !important;
                    margin-left: 24px;
                    min-height: auto !important;
                    font-family: Roboto;
                }
            `,
            formInputWrapper: css`
                select {
                    background-color: #ffffff !important;
                    border-radius: 16px !important;
                    padding: 12px 24px !important;
                    min-height: 48px !important;
                    border: 1px solid #838b90;
                    font-size: ${TYPOGRAPHY.size.smaller} !important;
                    font-weight: ${TYPOGRAPHY.weight.base} !important;
                    line-height: 14px !important;
                    color: #333333 !important;
                    min-height: auto !important;
                    font-family: Roboto !important;
                    margin-bottom: 24px;
                }

                span[class^="IconWrapper"] {
                    background: url("/userFiles/images/chevronDown.svg") no-repeat center;
                    svg {
                        display: none;
                    }
                }
            `,
        },
    },
    cardStyles: {
        css: css`
            background-color: #f5f6f7;
            border: 1px solid #e0dfe0;
            padding: 16px;
        `,
    },
    mainWrapper: {
        css: css`
            display: grid;
            gap: 24px;
            width: 100%;
            justify-items: center;
            align-items: stretch;

            grid-template-columns: repeat(4, 1fr);

            @media (min-width: 768px) and (max-width: 1024px) {
                grid-template-columns: repeat(2, 1fr);
                gap: 16px;
            }

            @media (max-width: 767px) {
                grid-template-columns: repeat(1, 1fr);
            }
        `,
    },
    wrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 20px;
            justify-content: center;
            align-items: stretch;
            width: 100%;
        `,
    },
    configureProductPlpStyles: {
        css: css`
            margin-top: 52px;
            margin-bottom: 12px;
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            color: ${NISCO.COLORS.primaryColor};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        margin-top: 60px;
                        margin-bottom: 24px;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1181px) {
                margin-top: 60px !important;
                margin-bottom: 24px !important;
            }
            @media (min-width: 1517px) {
                margin-top: 60px !important;
                margin-bottom: 24px !important;
            }
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    moreOptionsStyles: {
        css: css`
            margin-bottom: 8px;
            border: 2px solid ${NISCO.COLORS.primaryColor};
            padding: 4px 12px 4px 8px;
            border-radius: 16px;
            font-family: ${NISCO.TYPOGRAPHY.fontFamily.base};
            span {
                font-family: ${NISCO.TYPOGRAPHY.fontFamily.base};
                font-size: 12px;
                font-weight: 600;
                line-height: 16px;
                color: ${NISCO.COLORS.primaryColor} !important;
                display: flex;
                align-items: center;
                gap: 2px;
            }
        `,
    },
    wrenchIconStyles: {
        size: 16,
    },
    container: {
        css: css`
            margin-bottom: 64px;
            margin-top: 64px;
            padding:0px 64px;
            & > div {
                & > div {
                    justify-content: center;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 32px;
                        margin-bottom: 32px;
                          padding:0px 16px;
                    `,
                    css`
                        margin-top: 32px;
                        margin-bottom: 32px;
                           padding:0px 16px;
                    `,
                    css`
                        margin-top: 40px;
                        margin-bottom: 40px;
                            padding:0px 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    title: {
        variant: "h2",
        transform: "inherit",
        css: css`
            color: ${getColor("primary")};
            margin-bottom: 24px;
            text-align: center;
            font-size: 32px !important;
            line-height: 40px !important;
            font-weight: 600 !important;
            font-family: Roboto Condensed;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 16px;
                        font-weight: 600;
                        text-align: left;
                    `,
                    css`
                        margin-bottom: 16px;
                        text-align: left;
                    `,
                    css`
                        margin-bottom: 16px;
                    `,
                ]);
            }}
        `,
    },
    categoryContainer: {
        gap: 0,
    },
    innerCategoryContainer: {
        gap: 0,
        css: css`
            width: 100%;
            border: 1px solid ${COLORS.background.grayShade};
            background: ${COLORS.background.grayShade};
        `,
    },
    categoryImageItem: {
        width: 12,
        align: "middle",
        css: css`
            width: 100%;
            justify-content: center;
            img {
                max-height: 160px;
            }
        `,
    },
    imageWrapper: {
        css: css`
            background: ${COLORS.white};
            width: 100%;
            height: 205px;
            a {
                justify-content: center;
                height: 100%;
                &:focus {
                    outline: none !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 195px;
                    `,
                    css`
                        height: 195px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    categoryImage: {
        css: css`
            width: 100%;
            height: 100%;
            aspect-ratio: 1/1;
            object-fit: contain;
        `,
    },
    categoryWrapper: {
        css: css`
            padding: 32px;
            width: 100%;
            min-height: 240px;
        `,
    },
    categoryNameLinkItem: {
        width: 12,
        css: css`
            padding-bottom: 8px;
        `,
    },
    categoryNameLink: {
        css: css`
            width: 100%;
            height: 100%;
            span {
                color: ${getProp("theme.typography.p.color")} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.large};
                line-height: 24px;
            }
        `,
    },
    subCategoryItem: {
        width: 12,
        css: css`
            padding-top: 2px;
            padding-bottom: 7px;
        `,
    },
    subCategoryLink: {
        css: css`
            width: 100%;
            span {
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: 16px;
            }
        `,
    },
    viewMoreLinkItem: {
        width: 12,
        css: css`
            padding-top: 5px;
        `,
    },
    viewMoreLink: {
        typographyProps: {
            weight: "bold",
            ellipsis: true,
        },
    },
};

const styles = categoriesStyles;
const tabGroupStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: center;
            border: 1px solid #2b5197;
            border-radius: 4px;
            overflow: hidden;
            width: fit-content;
            margin: 0 auto 40px auto;

            button {
                flex: 1;
                border: none;
                outline: none;
                cursor: pointer;
                padding: 16px 24px;
                background: white;
                color: #2b5197;
                font-weight: 700;
                font-size: 18px;
                line-height: 18px;
                font-family: Roboto Condensed;
                text-transform: uppercase;
                border-right: 1px solid #2b5197;
                transition: all 0.2s ease-in-out;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 220px;

                &:last-child {
                    border-right: none;
                }

                &.active-tab {
                    background: #2b5197;
                    color: white;
                }
            }
        `,
    },
};

const NISBrandTopCategory: FC<Props> = ({
    loadBrandCategories,
    brandCategoriesParameter,
    id,
    products,
    loadBrandCategoryProducts,
}) => {
    const history = useHistory();
    const { value: brand } = useContext(BrandStateContext);
    const { isLoading, value: brandCategories } = useContext(BrandCategoriesStateContext);
    const [activeTab, setActiveTab] = useState(0);
    const [isScreenWide, setIsScreenWide] = useState<boolean>(true);

    useEffect(() => {
        const handleResize = () => {
            setIsScreenWide(window.innerWidth >= 768);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        loadBrandCategories(brandCategoriesParameter);
    }, []);

    useEffect(() => {
        if (brandCategories && brandCategories.length > 0) {
            const firstCategory = brandCategories[0];
            handleTabClick(firstCategory, 0);
        }
    }, [brandCategories]);

    if (isLoading || !brand || !brandCategories) return null;

    const topCategories = brandCategories.slice(0, 3);

    const handler = (e: React.MouseEvent) => {
        history.push(brand?.productListPagePath);
        e.preventDefault();
    };

    const handleTabClick = (category: BrandCategoryModel, index: number) => {
        setActiveTab(index);
        loadBrandCategoryProducts({
            ...({
                cardId: id,
                includeSuggestions: true,
                applyPersonalization: true,
                includeAttributes: ["includeOnProduct"],
                relevancy: true,
                includeProductsInSubCategories: true,
                categoryId: category.categoryId,
                brandIds: [brand.id],
                expand: ["attributes", "facets"],
                page: 1,
                pageSize: 4,
            } as any),
        });
    };

    return (
        <StyledWrapper {...styles.container} data-test-selector="brandCategories">
            <Typography {...styles.title}>{translate(`Top ${brand?.name} Products`)}</Typography>

            {isScreenWide ? (
                <StyledWrapper {...tabGroupStyles.wrapper}>
                    {topCategories.map((category, index) => {
                        const text = category.categoryShortDescription?.toUpperCase() ?? "";
                        return (
                            <button
                                key={category.categoryId}
                                className={activeTab === index ? "active-tab" : ""}
                                onClick={() => handleTabClick(category, index)}
                                title={text.length > 20 ? text : undefined}
                            >
                                {text}
                            </button>
                        );
                    })}
                </StyledWrapper>
            ) : (
                <Select
                    {...styles.topicsSelect}
                    value={activeTab}
                    onChange={e => {
                        const index = parseInt(e.target.value, 10);
                        handleTabClick(topCategories[index], index);
                    }}
                >
                    {topCategories.map((category, index) => (
                        <option key={category.categoryId} value={index}>
                            {category.categoryShortDescription}
                        </option>
                    ))}
                </Select>
            )}

            {!products || products.length === 0 ? (
                <StyledWrapper
                    css={css`
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 300px;
                    `}
                >
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            ) : (
                <StyledWrapper {...styles.mainWrapper}>
                    {products.map(product => (
                        <StyledWrapper
                            {...styles.cardStyles}
                            key={product.id}
                            data-test-selector={`productListProductCard${product.id}`}
                        >
                            <NISBrandTopCategoryProductsGridCard product={product} cardId={id} />
                        </StyledWrapper>
                    ))}
                </StyledWrapper>
            )}

            <StyledWrapper {...styles.buttonContainer}>
                <Button {...styles.button} onClick={handler}>
                    {translate("View All {0} Products").replace("{0}", brand.name)}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NISBrandTopCategory),
    definition: {
        group: "Brand Details",
        displayName: "NIS Brand Top Category",
    },
};

export default widgetModule;
